<template>
  <div class="d-inline-flex align-items-center user-select-none">
    <label v-if="authControl" :class="classList">
      <input
        v-bind="$attrs"
        :ref="`switch-${$attrs.id || 'no-id'}`"
        :checked="value"
        :value="value"
        class="switch-input form-check-input"
        false-value="uncheckedValue"
        true-value="value"
        type="checkbox"
        @change="handleChange"
        @click.stop="handleClick"
      />
      <span class="switch-slider" />
    </label>

    <div
      v-if="$slots.default || label"
      :class="[
        'd-flex align-items-center',
        { 'cursor-pointer': !$attrs.disabled && authControl }
      ]"
      @click.stop="
        !$attrs.disabled && authControl
          ? $refs[`switch-${$attrs.id || 'no-id'}`].click()
          : null
      "
    >
      <slot>
        <span
          :class="[
            { small: $attrs.size === 'sm' },
            { 'text-muted': $attrs.disabled }
          ]"
          class="align-middle mx-2"
        >
          {{ label }}
        </span>
      </slot>
    </div>

    <font-awesome-icon
      v-if="!authControl"
      :icon="value ? 'check' : 'times'"
      :class="`text-${value ? 'success' : 'danger'}`"
    />
  </div>
</template>

<script>
export default {
  name: 'BrbSwitch',
  props: {
    value: {
      default: false
    },
    label: String,
    enableAuth: [String, Array],
    disableAuth: [String, Array],
    permissionScope: String,
    withAuth: Boolean
  },
  computed: {
    classList() {
      return [
        'switch',
        'align-middle',
        // this.label ? 'switch-label' : '',
        this.$attrs.size ? `switch-${this.$attrs.size}` : '',
        this.$attrs.variant ? `switch-${this.$attrs.variant}` : 'switch-3d',
        `switch${this.$attrs.outline ? '-outline' : ''}-${
          this.$attrs.color || 'success'
        }${this.$attrs.outline === 'alt' ? '-alt' : ''}`,
        'form-check-label'
      ]
    },
    authControl() {
      if (this.withAuth) {
        const permissionName = this.value
          ? this.disableAuth || 'disable'
          : this.enableAuth || 'enable'
        return this.$hasPermission(
          permissionName,
          this.permissionScope || this.$permissionScope
        )
      }

      return true
    }
  },
  methods: {
    toggle(checked) {
      this.$emit('change', checked)
      this.$emit('input', checked)
    },
    handleClick(e) {
      this.$emit('click', e)
    },
    handleChange(event) {
      this.toggle(event.target.checked)
    }
  }
}
</script>
